import styled from "styled-components";

export const ViewerComments = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	padding-bottom: 5rem;
`;
